import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/auth',
      name: 'auth',
      components: {
        'auth': () => import('@/components/Auth')
      }
    },
    {
      path: '/tenders',
      name: 'Tenders',
      component: () => import('@/components/Tenders')
    },
    {
      path: '/mailings',
      name: 'Mailings',
      component: () => import('@/components/Mailings')
    },
    {
      path: '/mailings/:id',
      name: 'Mailing',
      component: () => import('@/components/Mailing')
    },
    {
      path: '/tenders/:id',
      name: 'Tender',
      component: () => import('@/components/Tender'),
      children: [
        {
          name: 'stage',
          path: 'stage/:stageId/',
          component: () => import('@/components/TenderStage')
        }
      ]
    },
    {
      path: '/tenders/agro/:id',
      name: 'TenderAgro',
      component: () => import('@/components/agro/Tender')
    },
    {
      path: '/participation',
      name: 'Participations',
      component: () => import('@/components/Participations')
    },
    {
      path: '/participation/agro/:id',
      name: 'ParticipationsAgro',
      component: () => import('@/components/agro/Participations')
    },
    {
      path: '/participation/:id',
      name: 'Participation',
      component: () => import('@/components/Participation')
    },
    {
      path: '/base',
      name: 'QuestionsBase',
      components: {
        default: () => import('@/components/QuestionsBase'),
        test: () => import('@/components/Question')
      }
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js